/**
 * @generated SignedSource<<3b963287a31b6a8bb3f809259e4c6f40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type certificateEmitDialogFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "certificateEmitDialogFragment";
};
export type certificateEmitDialogFragment$key = {
  readonly " $data"?: certificateEmitDialogFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"certificateEmitDialogFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "certificateEmitDialogFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Course",
  "abstractKey": null
};

(node as any).hash = "12840daebdd47480ff3491a5edb00681";

export default node;
